module.exports = __webpack_public_path__ + "img/turkey-tetrazzini.95d15f28.jpg";